import {mapGetters, mapMutations, mapActions} from 'vuex'
import {gotoAdobeService} from "@/utils/adobe";

import moment from 'moment'

export default {
  name: 'analysis',
  //---components
  //---data
  data () {
    return {}
  },
  //---hooks
  created: function () {
    if (!this.analysis) {
      this.$router.push({name: 'searchProperty'});
    }
  },
  computed: {
    ...mapGetters({
      content: 'APP/content',
      contacts: 'CONTACTS/contacts',
      analysis: 'ANALYSIS/analysis',
      client: 'CLIENT/client',
      URLParams: 'APP/URLParams',
    }),
    isPurchasedLast3Years: function () {
      let purchaseDate = this.analysis.purchase.purchaseDate ? this.analysis.purchase.purchaseDate : null;
      return purchaseDate !== null && moment().diff(moment(purchaseDate), 'years') < 3;
    },
  },
  //---data
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      getReportRequest: 'REPORT/REPORT_REQUEST_GET'
    }),
    _getValue(key) {
      let value = null;
      if (this.contacts) {
        value = this.contacts[key];
      } else if (this.URLParams[key]) {
        value = this.URLParams[key];
      }
      return value
    },
    generateReport() {
      this.loaderFlag(true);

      let payload = {
        userId: this.client.userId, //---old value 0
        prospectFirstName: this._getValue('firstName'),
        prospectLastName: this._getValue('lastName'),
        prospectPhone: this._getValue('phone'),
        prospectEmail: this._getValue('email'),
        getReport: true,
        sendReport: this.client.iFrameEmailReportToWebUser,
        sendReferral: this.client.sendReferral,
        affiliateCode: this.client.affiliateCode
      }

      this.getReportRequest({
        analyzedRecordId: this.analysis.analyzedRecordId,
        payload: payload
      }).then(()=>{
        this.$router.push({name: 'thanks'});
      }).catch( error => {
        this.$snotify.error(error);
      }).finally(()=>{
        this.loaderFlag(false);
      });
    },
    getAppeal() {
      window.open(process.env.VUE_APP_APPEAL_NOW_URL + this.analysis.discountCode)
    },
    startAppeal() {
      gotoAdobeService();
    }
  }
}
